import { render, staticRenderFns } from "./orderResolve.vue?vue&type=template&id=d44e420a&scoped=true"
import script from "./orderResolve.vue?vue&type=script&lang=js"
export * from "./orderResolve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44e420a",
  null
  
)

export default component.exports